import React from "react";
import { FiArrowRight, FiHome, FiSmile } from "react-icons/fi";
import { Link } from "react-router-dom";
import { usePublicLang } from "../../../config/i18n/public";

const AUDIENCE_OPTIONS = [
  {
    key: "care",
    href: "/pflegeeinrichtungen",
    Icon: FiHome,
  },
  {
    key: "family",
    href: "/angehoerige",
    Icon: FiSmile,
  },
];

function AudienceButton({ href, Icon, title, accent }) {
  return (
    <Link
      to={href}
      className="group flex min-h-[108px] w-full items-center justify-between gap-4 rounded-full border border-white/90 bg-white/88 px-6 py-5 text-left text-[#18306f] shadow-[0_24px_70px_-32px_rgba(24,48,111,0.82)] backdrop-blur-md transition duration-300 hover:-translate-y-1 hover:bg-white focus:outline-none focus:ring-2 focus:ring-[#79B7FF]/70 sm:min-h-[124px] sm:px-8"
    >
      <span className="flex min-w-0 items-center gap-4">
        <span
          className={[
            "grid h-11 w-11 flex-none place-items-center rounded-full text-white shadow-md sm:h-12 sm:w-12",
            accent,
          ].join(" ")}
        >
          <Icon aria-hidden className="h-5 w-5 sm:h-6 sm:w-6" />
        </span>
        <span className="min-w-0 text-xl font-extrabold leading-tight sm:text-2xl">
          {title}
        </span>
      </span>
      <FiArrowRight
        aria-hidden
        className="h-5 w-5 flex-none text-[#5b76ba] transition duration-300 group-hover:translate-x-1 group-hover:text-[#18306f]"
      />
    </Link>
  );
}

export default function AudienceSelectionPage() {
  const { lang, setLang, copy } = usePublicLang();
  const c = copy.audience;

  return (
    <main className="relative min-h-[100dvh] overflow-hidden bg-[#eef3fb] text-[#18306f]">
      <img
        src="/homepage.png"
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover opacity-50"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.76),_rgba(238,243,251,0.54)_42%,_rgba(217,231,255,0.72)_100%)]"
      />
      <div
        aria-hidden
        className="absolute bottom-[-12rem] right-[-10rem] h-[34rem] w-[34rem] rounded-full bg-[#cfe0ff]/60 blur-3xl"
      />

      <header className="absolute inset-x-0 top-0 z-20">
        <div className="mx-auto mt-3 w-full px-3">
          <div className="flex items-center justify-between rounded-lg border border-white/70 bg-white/55 px-4 py-2 shadow-sm backdrop-blur-md sm:px-6 sm:py-3">
            <Link to="/" className="flex items-center gap-2 hover:opacity-85">
              <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg border border-[#DEF1FF] bg-white shadow-sm sm:h-12 sm:w-12">
                <img src="/steffi/logo.png" alt="SteffiCare Logo" className="h-10 w-10 object-contain sm:h-12 sm:w-12" />
              </div>
              <span className="ml-1 text-xl font-bold text-[#18306f] sm:text-2xl">
                SteffiCare
              </span>
            </Link>

            <div className="flex items-center rounded-lg border border-[#d7e3f6] bg-white/60 p-1">
              <button
                type="button"
                onClick={() => setLang("de")}
                className={`rounded-md px-2.5 py-1 text-xs font-semibold ${
                  lang === "de" ? "bg-[#18306f] text-white" : "text-[#5b76ba] hover:bg-[#eef3fb]"
                }`}
              >
                {copy.lang.de}
              </button>
              <button
                type="button"
                onClick={() => setLang("en")}
                className={`rounded-md px-2.5 py-1 text-xs font-semibold ${
                  lang === "en" ? "bg-[#18306f] text-white" : "text-[#5b76ba] hover:bg-[#eef3fb]"
                }`}
              >
                {copy.lang.en}
              </button>
            </div>
          </div>
        </div>
      </header>

      <section className="relative z-10 mx-auto flex min-h-[100dvh] w-full max-w-4xl flex-col items-center justify-center px-4 py-24 text-center sm:px-6">
        <div className="grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2">
          {AUDIENCE_OPTIONS.map(({ key, href, Icon }) => (
            <AudienceButton
              key={key}
              href={href}
              Icon={Icon}
              title={c.options[key].title}
              accent={key === "care" ? "bg-[#79B7FF]" : "bg-[#ffc15d]"}
            />
          ))}
        </div>
      </section>
    </main>
  );
}
